export const CAN_IMPORT_FROM_PMS = false;

export const SENDING_KEYS_LOADING_DELAY = 30000;

export const PMS_MEWS = "mews";
export const PMS_RESERVIT = "reservit";
export const PMS_WEBREZPRO = "webrezpro";
export const PMS_REZSTREAM = "rezstream";
export const PMS_CLOUDBEDS = "cloudbeds";
export const PMS_MAESTRO = "maestro";
export const PMS_BOOQABLE = "booqable";
